import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  fontFamily: '"Inter"',
  'heading-1': { fontFamily: 'Oswald', fontWeight: 700, fontSize: '42px', lineHeight: '60px' },
  'heading-2': { fontFamily: 'Oswald', fontWeight: 600, fontSize: '28px', lineHeight: '46px', letterSpacing: '0.02em' },
  'heading-3': { fontFamily: 'Oswald', fontWeight: 600, fontSize: '22px', lineHeight: '38px', letterSpacing: '0.02em' },
  'heading-4': { fontFamily: 'Oswald', fontWeight: 500, fontSize: '18px', lineHeight: '30px', letterSpacing: '0.02em' },
  'heading-5': { fontFamily: 'Oswald', fontWeight: 500, fontSize: '16px', lineHeight: '28px', letterSpacing: '0.02em' },
  'big-paragraph': { fontSize: '16px', fontWeight: 400, lineHeight: '20px' },
  'big-paragraph-bold': { fontSize: '16px', fontWeight: 600, lineHeight: '20px' },
  paragraph: { fontSize: '14px', fontWeight: 400, lineHeight: '20px' },
  'paragraph-bold': { fontSize: '14px', fontWeight: 600, lineHeight: '20px' },
  caption: { fontSize: '12px', fontWeight: 400, lineHeight: '16px', letterSpacing: '0.04em' },
  'caption-bold': { fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '0.04em' },
  badge: { fontSize: '10px', fontWeight: 500, lineHeight: '14px', letterSpacing: '0.08em', textTransform: 'uppercase' },
  'badge-bold': {
    fontSize: '10px',
    fontWeight: 700,
    lineHeight: '14px',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
};
